var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('v-sheet', {
    staticClass: "about-visual white--text image-card",
    staticStyle: {
      "background-image": "url(/images/sub/about/about-visual-bg.jpg)"
    }
  }, [_c('v-container', [_c('div', [_c('h2', {
    staticClass: "font-size-40 font-size-md-52 font-size-lg-72 line-height-13 mb-8 mb-lg-16"
  }, [_c('span', {
    staticClass: "font-weight-regular"
  }, [_vm._v("MICE 채용을 위한 "), _c('br'), _vm._v(" 가장 편리한 플랫폼 ")]), _vm._v("MICEPEC ")]), _c('p', {
    staticClass: "page-text--lg"
  }, [_vm._v(" 마이스펙은 MICE산업 유일한 채용플랫폼으로 기업 채용관리 및 DB구축, 개인 지원서 및 경력관리에 이르는 "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v(" MICE 채용 전반에 걸친 서비스를 제공합니다. ")])])])], 1), _c('v-sheet', {
    staticClass: "service-banner py-50 py-lg-90"
  }, [_c('v-container', [_c('v-row', {
    staticClass: "flex-md-row-reverse",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "mb-16 mb-md-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "service-banner__img"
  }, [_c('v-img', {
    staticClass: "w-100",
    attrs: {
      "src": "/images/sub/service/service-img.png"
    }
  })], 1)]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('h3', {
    staticClass: "tit tit--lg line-height-13 white--text mb-8 mb-lg-16"
  }, [_c('span', {
    staticStyle: {
      "color": "#FFE810"
    }
  }, [_vm._v("모집부터 접수까지 한번에")]), _vm._v(" "), _c('br'), _vm._v(" 마이스펙 공고 링크를 "), _c('br'), _vm._v(" 다양한 플랫폼에 올려보세요 ")]), _c('p', {
    staticClass: "page-text page-text--lg white--text"
  }, [_vm._v(" 지원자의 정보를 한눈에 볼 수 있는 것은 물론 마이스펙 인증 경력까지 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 확인할 수 있어 보다 효과적으로 채용매칭율을 높일 수 있습니다 ")])])], 1)], 1)], 1), _c('section', {
    staticClass: "sub-section"
  }, [_c('v-container', [_c('v-row', {
    staticClass: "kaban-contents flex-md-row-reverse"
  }, [_c('v-col', {
    staticClass: "mb-16 mb-md-0",
    attrs: {
      "cols": "12",
      "md": "6",
      "xl": "9",
      "offset-xl": "3"
    }
  }, [_c('v-img', {
    staticClass: "mx-auto mr-md-0",
    attrs: {
      "src": "/images/sub/service/service-img2.png",
      "max-width": "932"
    }
  })], 1), _c('v-col', {
    staticClass: "kaban-contents__txt",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('h3', {
    staticClass: "tit tit--lg line-height-13 mb-8 mb-lg-16"
  }, [_vm._v(" 지원자 칸반보드로 "), _c('br'), _vm._v(" 한눈에 들어오는 채용현황 ")]), _c('p', {
    staticClass: "page-text page-text--lg grey--text word-keep-all"
  }, [_vm._v(" 채용단계를 직접 설정할 수 있고, 지원자별 자유로운 이동이 가능하기에 "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" 모든 채용과정을 쉽게 관리할 수 있습니다 ")])])], 1)], 1)], 1), _c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-layout', {
    staticClass: "w-100 h-100 px-12 py-50 py-lg-90 text-center image-card",
    staticStyle: {
      "background-image": "url(/images/sub/service/service-img3-1.jpg)"
    },
    attrs: {
      "column": "",
      "align-center": ""
    }
  }, [_c('h3', {
    staticClass: "tit line-height-1 white--text mb-20 mb-lg-40"
  }, [_vm._v(" 먼저 사용해보세요 ")]), _c('v-layout', [_c('v-btn', {
    staticClass: "primary--text min-w-140px min-w-lg-160px mx-4",
    attrs: {
      "color": "white"
    },
    on: {
      "click": _vm.showFreeTrial
    }
  }, [_vm._v("무료체험하기")])], 1)], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-layout', {
    staticClass: "w-100 h-100 px-12 py-50 py-lg-90 text-center image-card",
    staticStyle: {
      "background-image": "url(/images/sub/service/service-img3-2.jpg)"
    },
    attrs: {
      "column": "",
      "align-center": ""
    }
  }, [_c('h3', {
    staticClass: "tit line-height-1 white--text mb-20 mb-lg-40"
  }, [_vm._v(" 솔루션 상담을 받아보세요+ ")]), _c('v-btn', {
    staticClass: "primary--text min-w-140px min-w-lg-160px",
    attrs: {
      "to": "/center/inquiry",
      "color": "white"
    }
  }, [_vm._v("문의하기")])], 1)], 1)], 1), _c('section', {
    staticClass: "sub-section"
  }, [_c('v-container', [_c('div', {
    staticClass: "mb-40 mb-lg-100 text-center"
  }, [_c('h3', {
    staticClass: "tit tit--lg line-height-13 mb-8 mb-lg-16"
  }, [_vm._v(" 소통이 편해지면 채용도 쉬워집니다 ")]), _c('p', {
    staticClass: "page-text page-text--lg grey--text word-keep-all"
  }, [_vm._v(" 이제 마이스펙 하나로 바꿔보세요 ")])]), _c('v-row', _vm._l(_vm.service, function (item) {
    return _c('v-col', {
      key: item.title,
      attrs: {
        "cols": "12",
        "sm": "6",
        "md": "4"
      }
    }, [_c('v-card', {
      staticClass: "h-100",
      attrs: {
        "elevation": "0",
        "color": "grey-f7",
        "rounded": "lg"
      }
    }, [_c('v-layout', {
      staticClass: "w-100 h-100",
      attrs: {
        "column": "",
        "justify-space-between": ""
      }
    }, [_c('div', {
      staticClass: "pa-20 pa-md-30 pa-lg-40"
    }, [_c('h4', {
      staticClass: "tit--sm primary--text line-height-1 mb-6 mb-lg-12"
    }, [_vm._v(" " + _vm._s(item.title) + " ")]), _c('p', {
      staticClass: "page-text line-height-15 grey--text word-keep-all",
      domProps: {
        "innerHTML": _vm._s(item.sc)
      }
    })]), _c('div', {
      staticClass: "pl-20 pl-md-30 pl-lg-40"
    }, [_c('v-img', {
      staticClass: "ml-auto",
      attrs: {
        "src": item.image,
        "max-width": "372"
      }
    })], 1)])], 1)], 1);
  }), 1)], 1)], 1), _c('section', {
    staticClass: "sub-section sub-section--link image-card",
    staticStyle: {
      "background-image": "url(/images/sub/service/service-img5.jpg)"
    }
  }, [_c('v-container', [_c('h3', {
    staticClass: "tit tit--lg font-size-lg-56 line-height-13 text-center mb-20 mb-lg-40"
  }, [_vm._v(" 소통이 편해지면 채용도 쉬워집니다 ")]), _c('v-layout', {
    attrs: {
      "justify-center": ""
    }
  }, [_c('v-btn', {
    staticClass: "min-w-140px min-w-lg-160px mx-4",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.showFreeTrial
    }
  }, [_vm._v("무료체험하기")]), _c('v-btn', {
    staticClass: "primary--text min-w-140px min-w-lg-160px mx-4",
    attrs: {
      "to": "/center/inquiry",
      "color": "white"
    }
  }, [_vm._v("문의하기")])], 1)], 1)], 1), _c('dialog-join', {
    ref: "dialog-join"
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }